import styled from 'styled-components'
import Colors from '../../theme/colors'
import Fonts from '../../theme/fonts'

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;

  * {
    font-family: ${Fonts.fontFamilies.Inter};
    font-style: normal;
    font-weight: normal;
    font-size: ${Fonts.fontSizes.p16};
    user-select: none;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    h2, h3 {
      text-align: center;
      font-family: ${Fonts.fontFamilies.Montserrat};
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      width: 50%;
    }

    h3 {
      color: ${Colors.Primary.GreyTextLight};
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      margin: 0px;
    }
  }

  section {
    display: grid;
    grid-column-gap: 40px;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
`

export default Styles

const CardContent = styled.article`
  position: relative;
  padding: 30px 30px 10px 30px;
  cursor: pointer;
  grid-row: 1;

  hr {
    margin: 0;
    margin-bottom: 24px;
    border-bottom: 1px solid ${Colors.Primary.Grey};
    border-top: 0;
    width: calc(100% - 20px);
  }

  header {
    position: relative;
    display: flex;
    flex-direction: row;
    padding-bottom: 30px;

    aside {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-around;

      h3, p {
        margin: 0px;
      }

      h3 {
        font-family: ${Fonts.fontFamilies.Montserrat};
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 24px;
      }

      p {
        font-family: ${Fonts.fontFamilies.Inter};
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 16px;
        color: ${Colors.Primary.GreyTextLight};
      }
    }
  }

  .radio-button {
    position: absolute;
    right: 24px;
    top: 24px;
    height: 0;
  }

  footer {
    p {
      margin: 0;
      margin-bottom: 12px;
      svg {
        margin-right: 17px;
      }
    }
  }

`

export { CardContent }
